import * as e from "zod";
//#region src/apiUrls.ts
var t = "https://order.api.myparcel.nl", n = "https://order.api.acceptance.myparcel.nl", r = { bodySerializer: (e) => JSON.stringify(e, (e, t) => typeof t == "bigint" ? t.toString() : t) };
Object.entries({
	$body_: "body",
	$headers_: "headers",
	$path_: "path",
	$query_: "query"
});
//#endregion
//#region src/generated/core/serverSentEvents.gen.ts
var i = ({ onRequest: e, onSseError: t, onSseEvent: n, responseTransformer: r, responseValidator: i, sseDefaultRetryDelay: a, sseMaxRetryAttempts: o, sseMaxRetryDelay: s, sseSleepFn: c, url: l, ...u }) => {
	let d, f = c ?? ((e) => new Promise((t) => setTimeout(t, e)));
	return { stream: async function* () {
		let c = a ?? 3e3, p = 0, m = u.signal ?? new AbortController().signal;
		for (; !m.aborted;) {
			p++;
			let a = u.headers instanceof Headers ? u.headers : new Headers(u.headers);
			d !== void 0 && a.set("Last-Event-ID", d);
			try {
				let t = {
					redirect: "follow",
					...u,
					body: u.serializedBody,
					headers: a,
					signal: m
				}, o = new Request(l, t);
				e && (o = await e(l, t));
				let s = await (u.fetch ?? globalThis.fetch)(o);
				if (!s.ok) throw Error(`SSE failed: ${s.status} ${s.statusText}`);
				if (!s.body) throw Error("No body in SSE response");
				let f = s.body.pipeThrough(new TextDecoderStream()).getReader(), p = "", ee = () => {
					try {
						f.cancel();
					} catch {}
				};
				m.addEventListener("abort", ee);
				try {
					for (;;) {
						let { done: e, value: t } = await f.read();
						if (e) break;
						p += t, p = p.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
						let a = p.split("\n\n");
						p = a.pop() ?? "";
						for (let e of a) {
							let t = e.split("\n"), a = [], o;
							for (let e of t) if (e.startsWith("data:")) a.push(e.replace(/^data:\s*/, ""));
							else if (e.startsWith("event:")) o = e.replace(/^event:\s*/, "");
							else if (e.startsWith("id:")) d = e.replace(/^id:\s*/, "");
							else if (e.startsWith("retry:")) {
								let t = Number.parseInt(e.replace(/^retry:\s*/, ""), 10);
								Number.isNaN(t) || (c = t);
							}
							let s, l = !1;
							if (a.length) {
								let e = a.join("\n");
								try {
									s = JSON.parse(e), l = !0;
								} catch {
									s = e;
								}
							}
							l && (i && await i(s), r && (s = await r(s))), n?.({
								data: s,
								event: o,
								id: d,
								retry: c
							}), a.length && (yield s);
						}
					}
				} finally {
					m.removeEventListener("abort", ee), f.releaseLock();
				}
				break;
			} catch (e) {
				if (t?.(e), o !== void 0 && p >= o) break;
				await f(Math.min(c * 2 ** (p - 1), s ?? 3e4));
			}
		}
	}() };
}, a = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, o = (e) => {
	switch (e) {
		case "form": return ",";
		case "pipeDelimited": return "|";
		case "spaceDelimited": return "%20";
		default: return ",";
	}
}, s = (e) => {
	switch (e) {
		case "label": return ".";
		case "matrix": return ";";
		case "simple": return ",";
		default: return "&";
	}
}, c = ({ allowReserved: e, explode: t, name: n, style: r, value: i }) => {
	if (!t) {
		let t = (e ? i : i.map((e) => encodeURIComponent(e))).join(o(r));
		switch (r) {
			case "label": return `.${t}`;
			case "matrix": return `;${n}=${t}`;
			case "simple": return t;
			default: return `${n}=${t}`;
		}
	}
	let s = a(r), c = i.map((t) => r === "label" || r === "simple" ? e ? t : encodeURIComponent(t) : l({
		allowReserved: e,
		name: n,
		value: t
	})).join(s);
	return r === "label" || r === "matrix" ? s + c : c;
}, l = ({ allowReserved: e, name: t, value: n }) => {
	if (n == null) return "";
	if (typeof n == "object") throw Error("Deeply-nested arrays/objects aren’t supported. Provide your own `querySerializer()` to handle these.");
	return `${t}=${e ? n : encodeURIComponent(n)}`;
}, u = ({ allowReserved: e, explode: t, name: n, style: r, value: i, valueOnly: a }) => {
	if (i instanceof Date) return a ? i.toISOString() : `${n}=${i.toISOString()}`;
	if (r !== "deepObject" && !t) {
		let t = [];
		Object.entries(i).forEach(([n, r]) => {
			t = [
				...t,
				n,
				e ? r : encodeURIComponent(r)
			];
		});
		let a = t.join(",");
		switch (r) {
			case "form": return `${n}=${a}`;
			case "label": return `.${a}`;
			case "matrix": return `;${n}=${a}`;
			default: return a;
		}
	}
	let o = s(r), c = Object.entries(i).map(([t, i]) => l({
		allowReserved: e,
		name: r === "deepObject" ? `${n}[${t}]` : t,
		value: i
	})).join(o);
	return r === "label" || r === "matrix" ? o + c : c;
}, d = /\{[^{}]+\}/g, f = ({ path: e, url: t }) => {
	let n = t, r = t.match(d);
	if (r) for (let t of r) {
		let r = !1, i = t.substring(1, t.length - 1), a = "simple";
		i.endsWith("*") && (r = !0, i = i.substring(0, i.length - 1)), i.startsWith(".") ? (i = i.substring(1), a = "label") : i.startsWith(";") && (i = i.substring(1), a = "matrix");
		let o = e[i];
		if (o == null) continue;
		if (Array.isArray(o)) {
			n = n.replace(t, c({
				explode: r,
				name: i,
				style: a,
				value: o
			}));
			continue;
		}
		if (typeof o == "object") {
			n = n.replace(t, u({
				explode: r,
				name: i,
				style: a,
				value: o,
				valueOnly: !0
			}));
			continue;
		}
		if (a === "matrix") {
			n = n.replace(t, `;${l({
				name: i,
				value: o
			})}`);
			continue;
		}
		let s = encodeURIComponent(a === "label" ? `.${o}` : o);
		n = n.replace(t, s);
	}
	return n;
}, p = ({ baseUrl: e, path: t, query: n, querySerializer: r, url: i }) => {
	let a = i.startsWith("/") ? i : `/${i}`, o = (e ?? "") + a;
	t && (o = f({
		path: t,
		url: o
	}));
	let s = n ? r(n) : "";
	return s.startsWith("?") && (s = s.substring(1)), s && (o += `?${s}`), o;
};
function m(e) {
	let t = e.body !== void 0;
	if (t && e.bodySerializer) return "serializedBody" in e ? e.serializedBody !== void 0 && e.serializedBody !== "" ? e.serializedBody : null : e.body === "" ? null : e.body;
	if (t) return e.body;
}
//#endregion
//#region src/generated/core/auth.gen.ts
var ee = async (e, t) => {
	let n = typeof t == "function" ? await t(e) : t;
	if (n) return e.scheme === "bearer" ? `Bearer ${n}` : e.scheme === "basic" ? `Basic ${btoa(n)}` : n;
}, te = ({ parameters: e = {}, ...t } = {}) => (n) => {
	let r = [];
	if (n && typeof n == "object") for (let i in n) {
		let a = n[i];
		if (a == null) continue;
		let o = e[i] || t;
		if (Array.isArray(a)) {
			let e = c({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "form",
				value: a,
				...o.array
			});
			e && r.push(e);
		} else if (typeof a == "object") {
			let e = u({
				allowReserved: o.allowReserved,
				explode: !0,
				name: i,
				style: "deepObject",
				value: a,
				...o.object
			});
			e && r.push(e);
		} else {
			let e = l({
				allowReserved: o.allowReserved,
				name: i,
				value: a
			});
			e && r.push(e);
		}
	}
	return r.join("&");
}, ne = (e) => {
	if (!e) return "stream";
	let t = e.split(";")[0]?.trim();
	if (t) {
		if (t.startsWith("application/json") || t.endsWith("+json")) return "json";
		if (t === "multipart/form-data") return "formData";
		if ([
			"application/",
			"audio/",
			"image/",
			"video/"
		].some((e) => t.startsWith(e))) return "blob";
		if (t.startsWith("text/")) return "text";
	}
}, re = (e, t) => t ? !!(e.headers.has(t) || e.query?.[t] || e.headers.get("Cookie")?.includes(`${t}=`)) : !1, ie = async ({ security: e, ...t }) => {
	for (let n of e) {
		if (re(t, n.name)) continue;
		let e = await ee(n, t.auth);
		if (!e) continue;
		let r = n.name ?? "Authorization";
		switch (n.in) {
			case "query":
				t.query ||= {}, t.query[r] = e;
				break;
			case "cookie":
				t.headers.append("Cookie", `${r}=${e}`);
				break;
			default:
				t.headers.set(r, e);
				break;
		}
	}
}, ae = (e) => p({
	baseUrl: e.baseUrl,
	path: e.path,
	query: e.query,
	querySerializer: typeof e.querySerializer == "function" ? e.querySerializer : te(e.querySerializer),
	url: e.url
}), oe = (e, t) => {
	let n = {
		...e,
		...t
	};
	return n.baseUrl?.endsWith("/") && (n.baseUrl = n.baseUrl.substring(0, n.baseUrl.length - 1)), n.headers = ce(e.headers, t.headers), n;
}, se = (e) => {
	let t = [];
	return e.forEach((e, n) => {
		t.push([n, e]);
	}), t;
}, ce = (...e) => {
	let t = new Headers();
	for (let n of e) {
		if (!n) continue;
		let e = n instanceof Headers ? se(n) : Object.entries(n);
		for (let [n, r] of e) if (r === null) t.delete(n);
		else if (Array.isArray(r)) for (let e of r) t.append(n, e);
		else r !== void 0 && t.set(n, typeof r == "object" ? JSON.stringify(r) : r);
	}
	return t;
}, h = class {
	fns = [];
	clear() {
		this.fns = [];
	}
	eject(e) {
		let t = this.getInterceptorIndex(e);
		this.fns[t] && (this.fns[t] = null);
	}
	exists(e) {
		let t = this.getInterceptorIndex(e);
		return !!this.fns[t];
	}
	getInterceptorIndex(e) {
		return typeof e == "number" ? this.fns[e] ? e : -1 : this.fns.indexOf(e);
	}
	update(e, t) {
		let n = this.getInterceptorIndex(e);
		return this.fns[n] ? (this.fns[n] = t, e) : !1;
	}
	use(e) {
		return this.fns.push(e), this.fns.length - 1;
	}
}, le = () => ({
	error: new h(),
	request: new h(),
	response: new h()
}), ue = te({
	allowReserved: !1,
	array: {
		explode: !0,
		style: "form"
	},
	object: {
		explode: !0,
		style: "deepObject"
	}
}), de = { "Content-Type": "application/json" }, fe = (e = {}) => ({
	...r,
	headers: de,
	parseAs: "auto",
	querySerializer: ue,
	...e
}), g = ((e = {}) => {
	let t = oe(fe(), e), n = () => ({ ...t }), r = (e) => (t = oe(t, e), n()), a = le(), o = async (e) => {
		let n = {
			...t,
			...e,
			fetch: e.fetch ?? t.fetch ?? globalThis.fetch,
			headers: ce(t.headers, e.headers),
			serializedBody: void 0
		};
		return n.security && await ie({
			...n,
			security: n.security
		}), n.requestValidator && await n.requestValidator(n), n.body !== void 0 && n.bodySerializer && (n.serializedBody = n.bodySerializer(n.body)), (n.body === void 0 || n.serializedBody === "") && n.headers.delete("Content-Type"), {
			opts: n,
			url: ae(n)
		};
	}, s = async (e) => {
		let { opts: t, url: n } = await o(e), r = {
			redirect: "follow",
			...t,
			body: m(t)
		}, i = new Request(n, r);
		for (let e of a.request.fns) e && (i = await e(i, t));
		let s = t.fetch, c;
		try {
			c = await s(i);
		} catch (e) {
			let n = e;
			for (let r of a.error.fns) r && (n = await r(e, void 0, i, t));
			if (n ||= {}, t.throwOnError) throw n;
			return t.responseStyle === "data" ? void 0 : {
				error: n,
				request: i,
				response: void 0
			};
		}
		for (let e of a.response.fns) e && (c = await e(c, i, t));
		let l = {
			request: i,
			response: c
		};
		if (c.ok) {
			let e = (t.parseAs === "auto" ? ne(c.headers.get("Content-Type")) : t.parseAs) ?? "json";
			if (c.status === 204 || c.headers.get("Content-Length") === "0") {
				let n;
				switch (e) {
					case "arrayBuffer":
					case "blob":
					case "text":
						n = await c[e]();
						break;
					case "formData":
						n = new FormData();
						break;
					case "stream":
						n = c.body;
						break;
					default:
						n = {};
						break;
				}
				return t.responseStyle === "data" ? n : {
					data: n,
					...l
				};
			}
			let n;
			switch (e) {
				case "arrayBuffer":
				case "blob":
				case "formData":
				case "text":
					n = await c[e]();
					break;
				case "json": {
					let e = await c.text();
					n = e ? JSON.parse(e) : {};
					break;
				}
				case "stream": return t.responseStyle === "data" ? c.body : {
					data: c.body,
					...l
				};
			}
			return e === "json" && (t.responseValidator && await t.responseValidator(n), t.responseTransformer && (n = await t.responseTransformer(n))), t.responseStyle === "data" ? n : {
				data: n,
				...l
			};
		}
		let u = await c.text(), d;
		try {
			d = JSON.parse(u);
		} catch {}
		let f = d ?? u, p = f;
		for (let e of a.error.fns) e && (p = await e(f, c, i, t));
		if (p ||= {}, t.throwOnError) throw p;
		return t.responseStyle === "data" ? void 0 : {
			error: p,
			...l
		};
	}, c = (e) => (t) => s({
		...t,
		method: e
	}), l = (e) => async (t) => {
		let { opts: n, url: r } = await o(t);
		return i({
			...n,
			body: n.body,
			headers: n.headers,
			method: e,
			onRequest: async (e, t) => {
				let r = new Request(e, t);
				for (let e of a.request.fns) e && (r = await e(r, n));
				return r;
			},
			serializedBody: m(n),
			url: r
		});
	};
	return {
		buildUrl: (e) => ae({
			...t,
			...e
		}),
		connect: c("CONNECT"),
		delete: c("DELETE"),
		get: c("GET"),
		getConfig: n,
		head: c("HEAD"),
		interceptors: a,
		options: c("OPTIONS"),
		patch: c("PATCH"),
		post: c("POST"),
		put: c("PUT"),
		request: s,
		setConfig: r,
		sse: {
			connect: l("CONNECT"),
			delete: l("DELETE"),
			get: l("GET"),
			head: l("HEAD"),
			options: l("OPTIONS"),
			patch: l("PATCH"),
			post: l("POST"),
			put: l("PUT"),
			trace: l("TRACE")
		},
		trace: c("TRACE")
	};
})(fe({
	baseUrl: "https://order.api.myparcel.nl",
	throwOnError: !0
})), _ = e.object({
	city: e.string().min(1).max(100).register(e.globalRegistry, { description: "The city of the address." }),
	countryCode: e.string().length(2).regex(/[A-Z]{2}/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
	street: e.string().min(1).max(100).register(e.globalRegistry, { description: "The street of the address." }),
	additionalInformation: e.string().min(1).max(100).register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().min(1).max(25).register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().min(1).max(15).register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().min(1).max(100).register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().min(1).max(100).register(e.globalRegistry, { description: "The state of the address." }).optional()
}).register(e.globalRegistry, { description: "A physical address." }), pe = e.enum(["status"]), v = e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"BOL"
]).register(e.globalRegistry, { description: "The carrier of the package." }), me = e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD"
]).register(e.globalRegistry, { description: "The carrier to select to ship a package with." }), he = e.string().length(2).regex(/[A-Z]{2}/).register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), y = e.object({
	groups: e.array(e.object({
		description: e.string().min(1).max(50).register(e.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: e.string().min(6).max(12).register(e.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: e.int().gte(1).lte(99999).register(e.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: e.object({
			currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
			integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
		}).register(e.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: e.object({
			unit: e.enum([
				"GRAM",
				"g",
				"kg"
			]).register(e.globalRegistry, { description: "The unit of weight." }),
			value: e.int().gte(1).lte(999999999)
		}).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: e.string().length(2).regex(/[A-Z]{2}/).register(e.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }).optional()
	}).register(e.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).min(1).max(100).register(e.globalRegistry, { description: "The list of item groups." }),
	purpose: e.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]).register(e.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: e.object({
		unit: e.enum([
			"GRAM",
			"g",
			"kg"
		]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: e.string().min(1).max(150).register(e.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(e.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), ge = e.object({
	groups: e.array(e.object({
		description: e.string().min(1).max(100).register(e.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: e.string().min(6).max(12).register(e.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: e.int().gte(1).lte(99999).register(e.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: e.object({
			currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
			integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
		}).register(e.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: e.object({
			unit: e.enum(["GRAM"]).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
			value: e.int().gte(1).lte(999999999)
		}).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: e.string().length(2).regex(/[A-Z]{2}/).register(e.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }).optional()
	}).register(e.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).min(1).max(100).register(e.globalRegistry, { description: "The list of item groups." }),
	purpose: e.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]).register(e.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: e.object({
		unit: e.enum(["GRAM"]).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: e.string().min(1).max(150).register(e.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(e.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), b = e.string().min(1).max(100).register(e.globalRegistry, { description: "The customer reference of the order." }), _e = e.enum([
	"EARLY_MORNING_DELIVERY",
	"EVENING_DELIVERY",
	"EXPRESS_DELIVERY",
	"MORNING_DELIVERY",
	"PICKUP_EXPRESS_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"STANDARD_DELIVERY"
]).register(e.globalRegistry, { description: "The delivery type of the shipment." }), ve = e.object({
	notifyOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: e.object({ date: e.iso.date().register(e.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(e.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}), x = e.object({
	options: ve.optional(),
	type: _e.optional()
}).register(e.globalRegistry, { description: "The delivery details of the shipment." }), ye = e.object({ date: e.iso.date().register(e.globalRegistry, { description: "The date at which to drop off the package." }).optional() }).register(e.globalRegistry, { description: "The drop-off details." }), S = e.object({
	currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
	integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
}).register(e.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), be = e.enum(["EU", "NON_EU"]).register(e.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), C = e.enum([
	"CANCELED",
	"COMPLETED",
	"DISCOVERED",
	"IMPORT_REQUESTED",
	"OPEN",
	"PROCESSING",
	"RETURNING"
]).register(e.globalRegistry, { description: "The status of the order." }), w = e.enum([
	"DIGITAL_STAMP",
	"ENVELOPE",
	"MAILBOX",
	"PACKAGE",
	"PALLET",
	"SMALL_PACKAGE",
	"UNFRANKED"
]).register(e.globalRegistry, { description: "The type of the package." }), xe = e.union([
	e.object({
		group: e.enum(["PICKING_AND_PACKING"]),
		name: e.enum(["PACKED"])
	}),
	e.object({
		group: e.enum(["DISPATCHING"]),
		name: e.enum(["READY_TO_SHIP"])
	}),
	e.object({
		group: e.enum(["DISPATCHING"]),
		name: e.enum(["LABELED"])
	}),
	e.object({
		group: e.enum(["DISPATCHING"]),
		name: e.enum(["HANDED_OVER"])
	}),
	e.object({
		group: e.enum(["UNTRACEABLE"]),
		name: e.enum(["LABELED"])
	}),
	e.object({
		group: e.enum(["SORTING"]),
		name: e.enum(["IN_SORTING_PROCESS"])
	}),
	e.object({
		group: e.enum(["DISTRIBUTING"]),
		name: e.enum(["OUT_FOR_DELIVERY"])
	}),
	e.object({
		group: e.enum(["DISTRIBUTING"]),
		name: e.enum(["AT_CUSTOMS"])
	}),
	e.object({
		group: e.enum(["DISTRIBUTING"]),
		name: e.enum(["AT_PICKUP_POINT"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["AT_AGREED_LOCATION"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["AT_RECIPIENT"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["AT_SENDER"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["MARKED_AS"])
	}),
	e.object({
		group: e.enum(["DELIVERED"]),
		name: e.enum(["PICKED_UP"])
	})
]), T = e.enum([
	"PAID",
	"PENDING",
	"UNPAID"
]).register(e.globalRegistry, { description: "The current payment status." }), Se = e.object({
	height: e.object({
		unit: e.enum(["MILLIMETER"]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The height." }).optional(),
	length: e.object({
		unit: e.enum(["MILLIMETER"]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The length." }).optional(),
	weight: e.object({
		unit: e.enum(["GRAM"]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The weight." }).optional(),
	width: e.object({
		unit: e.enum(["MILLIMETER"]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The width." }).optional()
}), E = e.object({
	height: e.object({
		unit: e.enum([
			"MILLIMETER",
			"mm",
			"cm",
			"m"
		]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The height." }).optional(),
	length: e.object({
		unit: e.enum([
			"MILLIMETER",
			"mm",
			"cm",
			"m"
		]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The length." }).optional(),
	weight: e.object({
		unit: e.enum([
			"GRAM",
			"g",
			"kg"
		]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The physical weight." }),
	width: e.object({
		unit: e.enum([
			"MILLIMETER",
			"mm",
			"cm",
			"m"
		]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The width." }).optional()
}).register(e.globalRegistry, { description: "The physical dimensions." }), Ce = e.union([he, be]), D = e.enum(["OUTBOUND", "INBOUND"]).register(e.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }), O = e.object({
	additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: e.object({ amount: e.object({
		currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
		integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
	}).register(e.globalRegistry, { description: "The amount to insure." }) }).register(e.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: e.object({ amount: e.object({
		currency: e.string().length(3).register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
		integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
	}).register(e.globalRegistry, { description: "The amount of the contribution." }) }).register(e.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional()
}), k = e.object({ customLabelText: e.object({ text: e.string().min(1).max(45).register(e.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(e.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional() }), A = O.and(k), j = e.enum(["ASC", "DESC"]).register(e.globalRegistry, { description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)." }), we = e.object({
	emailAddress: e.string().min(1).max(320).register(e.globalRegistry, { description: "An email address." }).optional(),
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().min(1).max(50).register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.enum(["BUSINESS"]).register(e.globalRegistry, { description: "Discriminator for business contacts." }),
	company: e.string().min(1).max(100).register(e.globalRegistry, { description: "The name of the company." }),
	attention: e.string().min(1).max(100).register(e.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: e.record(e.string(), e.string().min(1).max(20).register(e.globalRegistry, { description: "The VAT registration number for the given country." })).register(e.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The EORI number of the company." }).optional()
}), Te = e.object({
	emailAddress: e.string().min(1).max(320).register(e.globalRegistry, { description: "An email address." }).optional(),
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().min(1).max(50).register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.enum(["PRIVATE"]).register(e.globalRegistry, { description: "Discriminator for private contacts." }),
	name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the contact person." })
}), M = e.union([e.object({ type: e.literal("BUSINESS") }).and(we), e.object({ type: e.literal("PRIVATE") }).and(Te)]), Ee = e.object({
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().min(1).max(50).register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.enum(["BUSINESS"]).register(e.globalRegistry, { description: "Discriminator for business contacts." }),
	company: e.string().min(1).max(100).register(e.globalRegistry, { description: "The name of the company." }),
	attention: e.string().min(1).max(100).register(e.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: e.record(e.string(), e.string().min(1).max(20).register(e.globalRegistry, { description: "The VAT registration number for the given country." })).register(e.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: e.string().min(1).max(20).register(e.globalRegistry, { description: "The EORI number of the company." }).optional(),
	emailAddresses: e.array(e.string().min(1).max(320).register(e.globalRegistry, { description: "An email address." })).min(1).max(5).register(e.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(e.globalRegistry, { description: "A business contact that supports multiple email addresses." }), De = e.object({
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().min(1).max(50).register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.enum(["PRIVATE"]).register(e.globalRegistry, { description: "Discriminator for private contacts." }),
	name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the contact person." }),
	emailAddresses: e.array(e.string().min(1).max(320).register(e.globalRegistry, { description: "An email address." })).min(1).max(5).register(e.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(e.globalRegistry, { description: "A private contact that supports multiple email addresses." }), N = e.union([e.object({ type: e.literal("BUSINESS") }).and(Ee), e.object({ type: e.literal("PRIVATE") }).and(De)]), Oe = e.object({
	address: _.optional(),
	contact: M.optional()
}).register(e.globalRegistry, { description: "The billing details of an order." }), ke = e.object({
	id: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the sales channel." }),
	name: e.string().min(3).max(50).register(e.globalRegistry, { description: "The name of the sales channel at the time of import." })
}).register(e.globalRegistry, { description: "The external reference of the sales channel." }), Ae = e.object({
	name: e.enum([
		"BOL",
		"LIGHTSPEED",
		"MAGENTO",
		"PRESTA",
		"SHOPIFY",
		"WOOCOMMERCE"
	]).register(e.globalRegistry, { description: "The identifier of the external e-commerce platform." }),
	sourceId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(e.globalRegistry, { description: "The external reference of the ecommerce platform." }), je = e.object({
	source: e.enum(["SALES_CHANNEL"]),
	salesChannel: ke,
	ecommercePlatform: Ae
}), Me = e.object({ source: e.enum(["MYPARCEL_SHOP"]) }).register(e.globalRegistry, { description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel" }), Ne = e.union([e.object({ source: e.literal("SALES_CHANNEL") }).and(je), e.object({ source: e.literal("MYPARCEL_SHOP") }).and(Me)]), Pe = e.object({
	credited: e.boolean().register(e.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: e.union([e.string().regex(/^shop\/.{1,250}$/).register(e.globalRegistry, { description: "A shop principal identifier." }), e.string().regex(/^user\/.{1,250}$/).register(e.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: T.optional(),
	barcode: e.string().min(1).max(50).register(e.globalRegistry, { description: "The barcode of the label." }),
	delayed: e.boolean().register(e.globalRegistry, { description: "Whether the shipment is delayed." }),
	partnerBarcodes: e.array(e.string().min(1).max(50).register(e.globalRegistry, { description: "The barcode identifier associated with the shipment label." })).min(1).max(5).register(e.globalRegistry, { description: "The partner barcodes when the parcel is taken over by a partner carrier." }).optional()
}), Fe = e.object({
	credited: e.boolean().register(e.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: e.union([e.string().regex(/^shop\/.{1,250}$/).register(e.globalRegistry, { description: "A shop principal identifier." }), e.string().regex(/^user\/.{1,250}$/).register(e.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: T.optional()
}), Ie = e.object({
	type: e.enum(["IMPORTED"]),
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	origin: e.enum(["SALES_CHANNEL"]).register(e.globalRegistry, { description: "The origin of the note." }),
	text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of the note." }),
	author: e.string().min(1).max(200).register(e.globalRegistry, { description: "The author of the note." }).optional(),
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), Le = e.object({
	type: e.enum(["PRINCIPAL"]),
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	principal: e.string().min(1).max(100).register(e.globalRegistry, { description: "The principal who crated the note." }),
	text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of the note." }),
	author: e.string().min(1).max(200).register(e.globalRegistry, { description: "The author of the note." }).optional(),
	locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), Re = e.union([e.object({ type: e.literal("IMPORTED") }).and(Ie), e.object({ type: e.literal("PRINCIPAL") }).and(Le)]), P = e.union([
	e.object({
		address: _,
		location: e.object({
			name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().min(1).max(64).register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
			type: e.enum([
				"CLICK_COLLECT",
				"PARCEL_LOCKER",
				"PARCEL_POINT",
				"POST_OFFICE",
				"POST_POINT"
			]).register(e.globalRegistry, { description: "The bpost pickup location type." })
		}).register(e.globalRegistry, { description: "The pickup location details." })
	}).register(e.globalRegistry, { description: "The bpost pickup details." }),
	e.object({
		address: _,
		location: e.object({
			name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().min(1).max(64).register(e.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(e.globalRegistry, { description: "The pickup location details." }),
		retailNetworkId: e.enum(["PNPNL-01", "PNPBE-01"]).register(e.globalRegistry, { description: "PostNL Retail network ID." })
	}).register(e.globalRegistry, { description: "The PostNL pickup details." }),
	e.object({
		address: _,
		location: e.object({
			name: e.string().min(1).max(200).register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().min(1).max(64).register(e.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(e.globalRegistry, { description: "The pickup location details." })
	}).register(e.globalRegistry, { description: "The general pickup details." })
]), ze = e.object({
	carrier: v,
	direction: D,
	disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
	packageType: e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE",
		"UNFRANKED"
	]).register(e.globalRegistry, { description: "The type of the package." }),
	recipient: e.object({
		address: _,
		contact: N
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: x.optional(),
	options: O.optional(),
	pickup: P.optional(),
	sender: e.object({
		address: _,
		contact: M
	}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
}), Be = e.object({
	id: e.string().min(1).register(e.globalRegistry, { description: "The unique identifier of the shipment." }),
	carrier: v,
	createdAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	direction: D,
	hidden: e.boolean().register(e.globalRegistry, { description: "Whether the shipment is hidden." }),
	packageType: w,
	recipient: e.object({
		address: _.optional(),
		contact: N.optional()
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: ge.optional(),
	delivery: x.optional(),
	dropOff: ye.optional(),
	label: e.union([Pe, Fe]).optional(),
	multicollo: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier for a multicollo shipment group." }),
		totalPackages: e.int().gte(2).lte(20).register(e.globalRegistry, { description: "The total number of individual packages included within this specific multicollo shipment group." })
	}).register(e.globalRegistry, { description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group." }).optional(),
	options: A.optional(),
	pickup: P.optional(),
	price: S.optional(),
	sender: e.object({
		address: _,
		contact: M
	}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
}).register(e.globalRegistry, { description: "The shipment properties of a package." }), Ve = e.object({ sourceId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The order line ID as defined in the source system." }) }).register(e.globalRegistry, { description: "The external reference of the order line." }), He = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
	product: e.object({
		name: e.string().min(1).max(250).register(e.globalRegistry, { description: "The name of the product." }),
		ean: e.union([e.string().length(8), e.string().length(13)]).optional(),
		sku: e.string().min(1).max(200).register(e.globalRegistry, { description: "The SKU of the product." }).optional(),
		id: e.uuid().register(e.globalRegistry, { description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined." }).optional()
	}).register(e.globalRegistry, { description: "The product of an order line." }),
	quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity of the product of the order line." }),
	externalReference: Ve.optional(),
	price: S.and(e.unknown().register(e.globalRegistry, { description: "The price of the product of the order line." })).optional()
}).register(e.globalRegistry, { description: "The line of the order" }), Ue = e.object({
	customsDeclaration: y.optional(),
	options: k.optional(),
	physicalProperties: E.optional()
}), We = e.object({
	lines: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity of the product of the order line." })
	})).min(1).max(100).optional(),
	physicalProperties: E.optional()
}), Ge = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." }),
	status: xe,
	physicalProperties: Se.optional(),
	lines: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity that the package contains" })
	})).min(1).max(100).register(e.globalRegistry, { description: "The order lines related to the package." }).optional(),
	shipment: Be.optional()
}), Ke = e.object({
	customsDeclaration: y.optional(),
	options: k.optional(),
	physicalProperties: E.optional(),
	shipment: e.object({
		carrier: me,
		direction: D,
		disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
		packageType: w,
		recipient: e.object({
			address: _,
			contact: N
		}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
		customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
		delivery: x.optional(),
		options: O.optional(),
		pickup: P.optional(),
		sender: e.object({
			address: _,
			contact: M
		}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
	})
}), qe = e.object({
	carrier: v.optional(),
	customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: ge.optional(),
	delivery: x.optional(),
	direction: D.optional(),
	disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: e.int().gte(1).lte(20).optional(),
	options: A.optional(),
	packageType: w.optional(),
	pickup: P.optional(),
	recipient: e.object({
		address: _.optional(),
		contact: N.optional()
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(e.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), Je = e.union([e.object({
	shopId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: b.optional(),
	package: Ke
}), e.object({
	shopId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: b.optional(),
	multicollo: e.object({
		packages: e.array(Ue).min(2).max(20),
		shipment: e.object({
			carrier: me,
			direction: D,
			disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
			packageType: w,
			recipient: e.object({
				address: _,
				contact: N
			}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
			customContractId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
			delivery: x.optional(),
			options: O.optional(),
			pickup: P.optional(),
			sender: e.object({
				address: _,
				contact: M
			}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
		})
	})
})]), Ye = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	packages: e.array(We).min(1).max(25)
}), F = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." }),
	customsDeclaration: y.optional(),
	options: k.optional(),
	physicalProperties: E.optional()
}), Xe = e.union([e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: ze,
	packages: e.array(F).min(1).max(25)
}), e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: ze,
	multicollo: e.array(F).min(2).max(25)
})]), Ze = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	orderedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	price: S,
	shopId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	status: C,
	assignedUserId: e.string().min(1).max(50).register(e.globalRegistry, { description: "The user ID assigned to the order." }).optional(),
	billingDetails: Oe.optional(),
	customerReference: b.optional(),
	externalReferences: Ne.and(e.unknown().register(e.globalRegistry, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." })).optional(),
	lines: e.array(He).min(1).max(100).register(e.globalRegistry, { description: "The lines of the order" }).optional(),
	notes: e.array(Re).min(1).max(100).register(e.globalRegistry, { description: "The notes of the order." }).optional(),
	packages: e.array(Ge).min(1).max(25).register(e.globalRegistry, { description: "The packages of the order." }).optional(),
	shipping: qe.optional()
}), I = e.object({
	type: e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().min(1).max(100).register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().min(1).max(5e3).register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), L = I.and(e.object({
	type: e.enum(["urn:problem:client"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string().min(1).max(5e3),
		pointer: e.string().min(1).max(200).register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(e.globalRegistry, { description: "Detailed information regarding the violations." })
})), R = I.and(e.object({
	type: e.enum(["urn:problem:server"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(500).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
})), Qe = I.and(e.object({
	type: e.enum(["urn:problem:invalid-request-syntax"]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string().min(1).max(5e3),
		pointer: e.string().min(1).max(200).register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).min(1).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), $e = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of the note." }),
		author: e.string().min(1).max(200).register(e.globalRegistry, { description: "The author of the note." }).optional(),
		locale: e.union([e.string().length(5).register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().length(2).register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional()
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for adding an order note." }),
	path: e.never().optional(),
	query: e.never().optional()
}), et = e.array(e.union([
	e.object({
		status: e.literal(200),
		ids: e.array(e.uuid()).min(1)
	}),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), tt = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		userId: e.string().min(1).max(50).register(e.globalRegistry, { description: "User to assign to these orders." })
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for assigning orders to an user." }),
	path: e.never().optional(),
	query: e.never().optional()
}), nt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), rt = e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(e.globalRegistry, { description: "Body for canceling orders." }),
	path: e.never().optional(),
	query: e.never().optional()
}), it = e.array(e.union([
	e.object({ status: e.literal(200) }),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), at = e.object({
	body: e.array(Je).min(1).max(50).register(e.globalRegistry, { description: "Body for creating an order with shippable packages." }),
	path: e.never().optional(),
	query: e.never().optional()
}), ot = e.array(e.union([
	e.object({
		status: e.literal(201),
		id: e.uuid()
	}),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per item." }), st = e.object({
	body: e.array(Ye).min(1).max(50).register(e.globalRegistry, { description: "Body adding packages to orders" }),
	path: e.never().optional(),
	query: e.never().optional()
}), ct = e.array(e.union([
	e.object({
		status: e.literal(200),
		ids: e.array(e.uuid()).min(1)
	}),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), lt = e.object({
	body: e.array(Xe).min(1).max(50).register(e.globalRegistry, { description: "Body preparing packages for shipment" }),
	path: e.never().optional(),
	query: e.never().optional()
}), ut = e.array(e.union([
	e.object({ status: e.literal(200) }),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), dt = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		packageIds: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(25)
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for unpreparing packages for shipment" }),
	path: e.never().optional(),
	query: e.never().optional()
}), ft = e.array(e.union([
	e.object({ status: e.literal(200) }),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), pt = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		noteId: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
		text: e.string().min(1).max(2500).register(e.globalRegistry, { description: "The text of the note." })
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for editing an order note." }),
	path: e.never().optional(),
	query: e.never().optional()
}), mt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), ht = e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(e.globalRegistry, { description: "Body for importing an order." }),
	path: e.never().optional(),
	query: e.never().optional()
}), gt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), _t = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		aggregation: e.tuple([pe]).register(e.globalRegistry, { description: "Fields to summarize data for based on the query." }).optional(),
		filter: e.object({
			assignedUserId: e.array(e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the user." })).min(1).max(100).optional(),
			carrier: e.array(v).min(1).max(15).optional(),
			hasAssignedUser: e.enum(["true", "false"]).register(e.globalRegistry, { description: "Whether the order has an assigned user or not." }).optional(),
			hasNotes: e.enum(["true", "false"]).register(e.globalRegistry, { description: "Whether the order has notes or not." }).optional(),
			orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(100).optional(),
			orderedAt: e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<datetime>((\d\d[2468][048]|\d\d[13579][26]|\d\d0[48]|[02468][048]00|[13579][26]00)-02-29|\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\d|3[01])|(0[469]|11)-(0[1-9]|[12]\d|30)|(02)-(0[1-9]|1\d|2[0-8])))T([01]\d|2[0-3]):[0-5]\d(:[0-5]\d(\.\d+)?)?(Z|([+-]\d{2}:?\d{2})))$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).min(1).max(2).optional(),
			packageStatusGroup: e.array(e.enum([
				"PICKING_AND_PACKING",
				"DISPATCHING",
				"UNTRACEABLE",
				"SORTING",
				"DISTRIBUTING",
				"DELIVERED"
			])).min(1).max(6).optional(),
			packageType: e.array(w).min(1).max(7).optional(),
			price: e.array(e.string().regex(/^(?<inequalitySymbol>gt|gte|lt|lte)\s(?<number>\d{1,15}(?:.\d{0,2})?)$/).register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a number with a maximum precision of 2." })).min(1).max(2).optional(),
			regionCode: e.array(Ce).min(1).max(100).optional(),
			salesChannelId: e.array(e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the sales channel." })).min(1).max(100).optional(),
			shipmentDelayed: e.enum(["true", "false"]).register(e.globalRegistry, { description: "Whether the order has a package with a delayed shipment or not." }).optional(),
			shipmentDirection: e.array(D).min(1).max(2).optional(),
			shipmentPaymentStatus: e.array(T).min(1).max(3).optional(),
			shopId: e.array(e.string().min(1).max(50).register(e.globalRegistry, { description: "The unique identifier of the shop." })).min(1).max(100).optional(),
			status: e.array(C).min(1).max(7).optional()
		}).optional(),
		limit: e.int().gte(0).lte(50).nullish().default(50),
		pageToken: e.string().min(4).max(500).register(e.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		query: e.string().min(1).max(500).register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: e.object({
			customerReference: j.optional(),
			orderedAt: j.optional(),
			price: j.optional(),
			sourceId: j.optional()
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `orderedAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
}), vt = e.object({
	results: e.array(Ze).min(0).max(50).register(e.globalRegistry, { description: "The list of orders." }),
	total: e.object({
		relation: e.enum(["eq", "gte"]).register(e.globalRegistry, { description: "The relation of the total number of orders." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of orders." })
	}),
	aggregations: e.object({ status: e.tuple([
		e.object({
			key: C,
			count: e.int().gte(0)
		}),
		e.object({
			key: C,
			count: e.int().gte(0)
		}),
		e.object({
			key: C,
			count: e.int().gte(0)
		}),
		e.object({
			key: C,
			count: e.int().gte(0)
		}),
		e.object({
			key: C,
			count: e.int().gte(0)
		}),
		e.object({
			key: C,
			count: e.int().gte(0)
		}),
		e.object({
			key: C,
			count: e.int().gte(0)
		})
	]).optional() }).optional(),
	nextPageToken: e.string().min(1).max(500).register(e.globalRegistry, { description: "The next page token to retrieve the next page of orders." }).optional()
}).register(e.globalRegistry, { description: "The found orders." }), yt = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		shipmentLabelsLayout: e.enum(["INTERLEAVED"]).register(e.globalRegistry, { description: "How shipment labels are included alongside the packing slips in the resulting PDF. `INTERLEAVED` outputs each packing slip immediately followed by its shipment label. When the parameter is omitted, no shipment labels are included and only packing slips are rendered." }).optional(),
		orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(50).register(e.globalRegistry, { description: "The orderId of the order to include in the packing slips. A maximum of 50 orders can be included in the request. When packageId is provided, exactly one orderId is allowed." }),
		packageId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(20).register(e.globalRegistry, { description: "The packageId of the package to include in the packing slips. The packageIds must belong to the single orderId in the request and a maximum of 20 packageIds can be included." }).optional()
	}),
	headers: e.object({ Accept: e.enum(["application/pdf"]) })
}), bt = e.string().register(e.globalRegistry, { description: "Packing slips PDF." }), xt = e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).min(1).max(50).register(e.globalRegistry, { description: "The orderId of the order to include in the picklist. A maximum of 50 orders can be included in the request." }) }),
	headers: e.object({ Accept: e.enum(["application/pdf"]) })
}), St = e.string().register(e.globalRegistry, { description: "Picklist PDF." }), Ct = e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		noteIds: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." })).min(1).max(150).register(e.globalRegistry, { description: "Note IDs to remove from the order." })
	})).min(1).max(50).register(e.globalRegistry, { description: "Body for removing order notes." }),
	path: e.never().optional(),
	query: e.never().optional()
}), wt = e.array(e.union([
	e.object({ status: e.literal(200) }),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), Tt = e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).min(1).max(50).register(e.globalRegistry, { description: "Body for unassigning orders from an user." }),
	path: e.never().optional(),
	query: e.never().optional()
}), Et = e.array(e.union([
	e.object({ status: e.literal(200) }),
	L,
	R
])).min(1).max(50).register(e.globalRegistry, { description: "The result per ID." }), z = e.object({
	city: e.string().register(e.globalRegistry, { description: "The city of the address." }),
	countryCode: e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }),
	street: e.string().register(e.globalRegistry, { description: "The street of the address." }),
	additionalInformation: e.string().register(e.globalRegistry, { description: "Additional information about the address." }).optional(),
	boxNumber: e.string().register(e.globalRegistry, { description: "The box number of the address, only applicable for specific country codes." }).optional(),
	houseNumber: e.string().register(e.globalRegistry, { description: "The house number of the address." }).optional(),
	houseNumberSuffix: e.string().register(e.globalRegistry, { description: "The house number suffix of the address." }).optional(),
	postalCode: e.string().register(e.globalRegistry, { description: "The postal code of the address." }).optional(),
	region: e.string().register(e.globalRegistry, { description: "The region of the address." }).optional(),
	state: e.string().register(e.globalRegistry, { description: "The state of the address." }).optional()
}).register(e.globalRegistry, { description: "A physical address." }), Dt = e.union([e.enum(["status"]), e.string()]), B = e.union([e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD",
	"BOL"
]), e.string()]).register(e.globalRegistry, { description: "The carrier of the package." }), Ot = e.union([e.enum([
	"BPOST",
	"BRT",
	"CHEAP_CARGO",
	"DHL_EUROPLUS",
	"DHL_FOR_YOU",
	"DHL_PARCEL_CONNECT",
	"DPD",
	"GLS",
	"INPOST",
	"POSTNL",
	"POSTE_ITALIANE",
	"TRUNKRS",
	"UPS_EXPRESS_SAVER",
	"UPS_STANDARD"
]), e.string()]).register(e.globalRegistry, { description: "The carrier to select to ship a package with." }), kt = e.string().register(e.globalRegistry, { description: "ISO 3166-1 alpha-2 country code." }), At = e.object({
	groups: e.array(e.object({
		description: e.string().register(e.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: e.string().register(e.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: e.int().gte(1).lte(99999).register(e.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: e.object({
			currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
			integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
		}).register(e.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: e.object({
			unit: e.union([e.enum([
				"GRAM",
				"g",
				"kg"
			]), e.string()]).register(e.globalRegistry, { description: "The unit of weight." }),
			value: e.int().gte(1).lte(999999999)
		}).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: e.string().register(e.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }).optional()
	}).register(e.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).register(e.globalRegistry, { description: "The list of item groups." }),
	purpose: e.union([e.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]), e.string()]).register(e.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: e.object({
		unit: e.union([e.enum([
			"GRAM",
			"g",
			"kg"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: e.string().register(e.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(e.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), jt = e.object({
	groups: e.array(e.object({
		description: e.string().register(e.globalRegistry, { description: "A clear and detailed description of the goods within this group." }),
		hsCode: e.string().register(e.globalRegistry, { description: "The Harmonized System (HS) code for the goods in this group, a globally recognized classification for traded products." }),
		numberOfItems: e.int().gte(1).lte(99999).register(e.globalRegistry, { description: "The total quantity of individual items within this specific group." }),
		totalValue: e.object({
			currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
			fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
			integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
		}).register(e.globalRegistry, { description: "The total declared value of all items within this group." }),
		totalWeight: e.object({
			unit: e.union([e.enum(["GRAM"]), e.string()]).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
			value: e.int().gte(1).lte(999999999)
		}).register(e.globalRegistry, { description: "The total weight of all items within this specific group." }),
		countryCodeOfOrigin: e.string().register(e.globalRegistry, { description: "The ISO 3166-1 alpha-2 country code indicating where the goods in this group originated." }).optional()
	}).register(e.globalRegistry, { description: "A consolidated group of items within a customs declaration that share common customs attributes." })).register(e.globalRegistry, { description: "The list of item groups." }),
	purpose: e.union([e.enum([
		"COMMERCIAL_GOODS",
		"COMMERCIAL_SAMPLE",
		"DOCUMENTS",
		"GIFT",
		"RETURNED_GOODS"
	]), e.string()]).register(e.globalRegistry, { description: "The primary reason or purpose for the international shipment." }),
	totalWeight: e.object({
		unit: e.union([e.enum(["GRAM"]), e.string()]).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The total weight of all items declared within this customs declaration." }),
	invoiceNumber: e.string().register(e.globalRegistry, { description: "The identifying number of the commercial invoice associated with this shipment." }).optional()
}).register(e.globalRegistry, { description: "The official declaration of goods for customs clearance purposes during international shipment." }), Mt = e.string().register(e.globalRegistry, { description: "The customer reference of the order." }), Nt = e.union([e.enum([
	"EARLY_MORNING_DELIVERY",
	"EVENING_DELIVERY",
	"EXPRESS_DELIVERY",
	"MORNING_DELIVERY",
	"PICKUP_EXPRESS_DELIVERY",
	"PICKUP_DELIVERY",
	"SAME_DAY_DELIVERY",
	"STANDARD_DELIVERY"
]), e.string()]).register(e.globalRegistry, { description: "The delivery type of the shipment." }), Pt = e.object({
	notifyOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Notify sender upon package delivery." }).optional(),
	preferredDate: e.object({ date: e.iso.date().register(e.globalRegistry, { description: "Recipient specified preferred delivery date." }) }).register(e.globalRegistry, { description: "This option allows you to set a preferred date for delivery, so a drop off date can be calculated." }).optional()
}), V = e.object({
	options: Pt.optional(),
	type: Nt.optional()
}).register(e.globalRegistry, { description: "The delivery details of the shipment." }), Ft = e.object({ date: e.iso.date().register(e.globalRegistry, { description: "The date at which to drop off the package." }).optional() }).register(e.globalRegistry, { description: "The drop-off details." }), It = e.object({
	currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
	fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
	integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
}).register(e.globalRegistry, { description: "A monetary value represented by split integral and fractional parts to avoid floating point errors." }), Lt = e.union([e.enum(["EU", "NON_EU"]), e.string()]).register(e.globalRegistry, { description: "A geographic area code that represents a specific list of countries." }), H = e.union([e.enum([
	"CANCELED",
	"COMPLETED",
	"DISCOVERED",
	"IMPORT_REQUESTED",
	"OPEN",
	"PROCESSING",
	"RETURNING"
]), e.string()]).register(e.globalRegistry, { description: "The status of the order." }), U = e.union([e.enum([
	"DIGITAL_STAMP",
	"ENVELOPE",
	"MAILBOX",
	"PACKAGE",
	"PALLET",
	"SMALL_PACKAGE",
	"UNFRANKED"
]), e.string()]).register(e.globalRegistry, { description: "The type of the package." }), Rt = e.union([
	e.object({
		group: e.union([e.enum(["PICKING_AND_PACKING"]), e.string()]),
		name: e.union([e.enum(["PACKED"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISPATCHING"]), e.string()]),
		name: e.union([e.enum(["READY_TO_SHIP"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISPATCHING"]), e.string()]),
		name: e.union([e.enum(["LABELED"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISPATCHING"]), e.string()]),
		name: e.union([e.enum(["HANDED_OVER"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["UNTRACEABLE"]), e.string()]),
		name: e.union([e.enum(["LABELED"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["SORTING"]), e.string()]),
		name: e.union([e.enum(["IN_SORTING_PROCESS"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISTRIBUTING"]), e.string()]),
		name: e.union([e.enum(["OUT_FOR_DELIVERY"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISTRIBUTING"]), e.string()]),
		name: e.union([e.enum(["AT_CUSTOMS"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DISTRIBUTING"]), e.string()]),
		name: e.union([e.enum(["AT_PICKUP_POINT"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["AT_AGREED_LOCATION"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["AT_RECIPIENT"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["AT_SENDER"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["MARKED_AS"]), e.string()])
	}),
	e.object({
		group: e.union([e.enum(["DELIVERED"]), e.string()]),
		name: e.union([e.enum(["PICKED_UP"]), e.string()])
	})
]), zt = e.union([e.enum([
	"PAID",
	"PENDING",
	"UNPAID"
]), e.string()]).register(e.globalRegistry, { description: "The current payment status." }), Bt = e.object({
	height: e.object({
		unit: e.union([e.enum(["MILLIMETER"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The height." }).optional(),
	length: e.object({
		unit: e.union([e.enum(["MILLIMETER"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The length." }).optional(),
	weight: e.object({
		unit: e.union([e.enum(["GRAM"]), e.string()]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The weight." }).optional(),
	width: e.object({
		unit: e.union([e.enum(["MILLIMETER"]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The width." }).optional()
}), W = e.object({
	height: e.object({
		unit: e.union([e.enum([
			"MILLIMETER",
			"mm",
			"cm",
			"m"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The height." }).optional(),
	length: e.object({
		unit: e.union([e.enum([
			"MILLIMETER",
			"mm",
			"cm",
			"m"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The length." }).optional(),
	weight: e.object({
		unit: e.union([e.enum([
			"GRAM",
			"g",
			"kg"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of weight." }),
		value: e.int().gte(1).lte(999999999)
	}).register(e.globalRegistry, { description: "The physical weight." }),
	width: e.object({
		unit: e.union([e.enum([
			"MILLIMETER",
			"mm",
			"cm",
			"m"
		]), e.string()]).register(e.globalRegistry, { description: "The unit of measurement for length, width, or height." }),
		value: e.int().gte(1).lte(1e6).register(e.globalRegistry, { description: "The dimension value." })
	}).register(e.globalRegistry, { description: "The width." }).optional()
}).register(e.globalRegistry, { description: "The physical dimensions." }), Vt = e.union([kt, Lt]), G = e.union([e.enum(["OUTBOUND", "INBOUND"]), e.string()]).register(e.globalRegistry, { description: "The direction of the shipment. OUTBOUND is from sender to recipient, INBOUND is from recipient to sender." }), K = e.object({
	additionalInsurance: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Provides enhanced insurance coverage beyond the standard amount." }).optional(),
	deliverAtPostalPoint: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Indicates that the parcel will be delivered to a designated postal service point rather than the recipient's address, requiring the recipient to collect it from that location." }).optional(),
	freshFood: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment as containing perishable, non-frozen food items, ensuring appropriate handling procedures are applied to maintain freshness and prevent spoilage during transit." }).optional(),
	frozen: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Specifies that the shipment contains items that must remain frozen, necessitating strict, continuous temperature-controlled environments throughout the transit process to prevent thawing." }).optional(),
	hideSender: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Omits the sender's information from the shipping label, maintaining sender anonymity in the delivery process." }).optional(),
	insurance: e.object({ amount: e.object({
		currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
		integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
	}).register(e.globalRegistry, { description: "The amount to insure." }) }).register(e.globalRegistry, { description: "Provides standard insurance coverage up to the specified monetary amount." }).optional(),
	noTracking: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Disables all tracking and tracing capabilities for the shipment." }).optional(),
	oversizedPackage: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment as exceeding standard size limitations, requiring special handling procedures and potentially incurring additional fees." }).optional(),
	printReturnLabelAtDropOff: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Provides the recipient with a digital identifier that can be presented at a drop-off location to print the return label on-site. This option is only applicable for inbound shipments." }).optional(),
	priorityDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Designates the shipment for expedited processing and transport through the delivery network, often resulting in a faster transit time compared to standard services." }).optional(),
	recipientOnlyDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Restricts delivery exclusively to the named recipient, requiring verification of recipient identity and prohibiting delivery to anyone else at the same address." }).optional(),
	requiresAgeVerification: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires the recipient to provide valid identification to verify they meet the minimum age requirement before the package can be released, typically used for age-restricted items." }).optional(),
	requiresCashOnDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Mandates that the carrier collect the full order amount in cash from the recipient upon delivery, ensuring payment is secured before the goods are handed over." }).optional(),
	requiresReceiptCode: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Requires the recipient to provide a specific verification code at the time of delivery, adding an extra layer of security and confirmation for sensitive shipments." }).optional(),
	requiresSignature: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Mandates that the recipient or authorized representative must provide a signature upon delivery, creating proof of receipt and transfer of responsibility." }).optional(),
	returnContributionFee: e.object({ amount: e.object({
		currency: e.string().register(e.globalRegistry, { description: "ISO 4217 three-letter currency code." }),
		fractional: e.int().gte(0).lt(100).register(e.globalRegistry, { description: "The fractional unit of the amount." }),
		integral: e.int().gte(0).register(e.globalRegistry, { description: "The whole unit of the amount." })
	}).register(e.globalRegistry, { description: "The amount of the contribution." }) }).register(e.globalRegistry, { description: "Specifies that the recipient must pay the designated contribution amount toward the cost of returning the item. This option is only applicable for inbound shipments." }).optional(),
	returnOnFirstFailedDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Instructs the carrier to return the package to the sender immediately after the first unsuccessful delivery attempt, bypassing the standard redelivery procedures or holding period." }).optional(),
	sameDayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Expedited delivery within the same calendar day that the shipping label is created." }).optional(),
	saturdayDelivery: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Enables delivery on Saturday, which is typically outside standard delivery days, ensuring the package arrives before the start of the following work week." }).optional(),
	scheduledCollection: e.record(e.string(), e.never()).register(e.globalRegistry, { description: "Arranges for the carrier to pick up the package from the sender's location, eliminating the need for the sender to drop off the package." }).optional()
}), q = e.object({ customLabelText: e.object({ text: e.string().register(e.globalRegistry, { description: "Allows adding personalized text to be printed on the shipping label, which can include special handling instructions or reference information." }) }).register(e.globalRegistry, { description: "Defines a custom text to be printed on the shipping label." }).optional() }), Ht = K.and(q), J = e.union([e.enum(["ASC", "DESC"]), e.string()]).register(e.globalRegistry, { description: "Specifies the ordering of results: ascending (ASC) or descending (DESC)." }), Ut = e.object({
	emailAddress: e.string().register(e.globalRegistry, { description: "An email address." }).optional(),
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.union([e.enum(["BUSINESS"]), e.string()]).register(e.globalRegistry, { description: "Discriminator for business contacts." }),
	company: e.string().register(e.globalRegistry, { description: "The name of the company." }),
	attention: e.string().register(e.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: e.record(e.string(), e.string().register(e.globalRegistry, { description: "The VAT registration number for the given country." })).register(e.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: e.string().register(e.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: e.string().register(e.globalRegistry, { description: "The EORI number of the company." }).optional()
}), Wt = e.object({
	emailAddress: e.string().register(e.globalRegistry, { description: "An email address." }).optional(),
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.union([e.enum(["PRIVATE"]), e.string()]).register(e.globalRegistry, { description: "Discriminator for private contacts." }),
	name: e.string().register(e.globalRegistry, { description: "The name of the contact person." })
}), Y = e.union([e.object({ type: e.literal("BUSINESS") }).and(Ut), e.object({ type: e.literal("PRIVATE") }).and(Wt)]), Gt = e.object({
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.union([e.enum(["BUSINESS"]), e.string()]).register(e.globalRegistry, { description: "Discriminator for business contacts." }),
	company: e.string().register(e.globalRegistry, { description: "The name of the company." }),
	attention: e.string().register(e.globalRegistry, { description: "The name of the contact person." }).optional(),
	vatNumbersByCountry: e.record(e.string(), e.string().register(e.globalRegistry, { description: "The VAT registration number for the given country." })).register(e.globalRegistry, { description: "A collection of VAT registration numbers of the company, indexed by ISO country code." }).optional(),
	voecNumber: e.string().register(e.globalRegistry, { description: "The VOEC number of the company." }).optional(),
	eoriNumber: e.string().register(e.globalRegistry, { description: "The EORI number of the company." }).optional(),
	emailAddresses: e.array(e.string().register(e.globalRegistry, { description: "An email address." })).register(e.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(e.globalRegistry, { description: "A business contact that supports multiple email addresses." }), Kt = e.object({
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	phoneNumber: e.string().register(e.globalRegistry, { description: "The phone number of the contact." }).optional(),
	type: e.union([e.enum(["PRIVATE"]), e.string()]).register(e.globalRegistry, { description: "Discriminator for private contacts." }),
	name: e.string().register(e.globalRegistry, { description: "The name of the contact person." }),
	emailAddresses: e.array(e.string().register(e.globalRegistry, { description: "An email address." })).register(e.globalRegistry, { description: "The email addresses of the contact. The first email address will be used as the primary email address. The remaining will be used as extra email addresses if the right permissions are present." }).optional()
}).register(e.globalRegistry, { description: "A private contact that supports multiple email addresses." }), X = e.union([e.object({ type: e.literal("BUSINESS") }).and(Gt), e.object({ type: e.literal("PRIVATE") }).and(Kt)]), qt = e.object({
	address: z.optional(),
	contact: Y.optional()
}).register(e.globalRegistry, { description: "The billing details of an order." }), Jt = e.object({
	id: e.string().register(e.globalRegistry, { description: "The unique identifier of the sales channel." }),
	name: e.string().register(e.globalRegistry, { description: "The name of the sales channel at the time of import." })
}).register(e.globalRegistry, { description: "The external reference of the sales channel." }), Yt = e.object({
	name: e.union([e.enum([
		"BOL",
		"LIGHTSPEED",
		"MAGENTO",
		"PRESTA",
		"SHOPIFY",
		"WOOCOMMERCE"
	]), e.string()]).register(e.globalRegistry, { description: "The identifier of the external e-commerce platform." }),
	sourceId: e.string().register(e.globalRegistry, { description: "The order ID as defined in the source system." })
}).register(e.globalRegistry, { description: "The external reference of the ecommerce platform." }), Xt = e.object({
	source: e.union([e.enum(["SALES_CHANNEL"]), e.string()]),
	salesChannel: Jt,
	ecommercePlatform: Yt
}), Zt = e.object({ source: e.union([e.enum(["MYPARCEL_SHOP"]), e.string()]) }).register(e.globalRegistry, { description: "This external reference is set when the order originates from an \"etiketten\" shipment. The only actions allowed on this type of order is cancel" }), Qt = e.union([e.object({ source: e.literal("SALES_CHANNEL") }).and(Xt), e.object({ source: e.literal("MYPARCEL_SHOP") }).and(Zt)]), $t = e.object({
	credited: e.boolean().register(e.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: e.union([e.string().register(e.globalRegistry, { description: "A shop principal identifier." }), e.string().register(e.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: zt.optional(),
	barcode: e.string().register(e.globalRegistry, { description: "The barcode of the label." }),
	delayed: e.boolean().register(e.globalRegistry, { description: "Whether the shipment is delayed." }),
	partnerBarcodes: e.array(e.string().register(e.globalRegistry, { description: "The barcode identifier associated with the shipment label." })).register(e.globalRegistry, { description: "The partner barcodes when the parcel is taken over by a partner carrier." }).optional()
}), en = e.object({
	credited: e.boolean().register(e.globalRegistry, { description: "Whether the label is credited by us." }),
	createdBy: e.union([e.string().register(e.globalRegistry, { description: "A shop principal identifier." }), e.string().register(e.globalRegistry, { description: "A user principal identifier." })]).optional(),
	paymentStatus: zt.optional()
}), tn = e.object({
	type: e.union([e.enum(["IMPORTED"]), e.string()]),
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	origin: e.union([e.enum(["SALES_CHANNEL"]), e.string()]).register(e.globalRegistry, { description: "The origin of the note." }),
	text: e.string().register(e.globalRegistry, { description: "The text of the note." }),
	author: e.string().register(e.globalRegistry, { description: "The author of the note." }).optional(),
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), nn = e.object({
	type: e.union([e.enum(["PRINCIPAL"]), e.string()]),
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
	notedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	principal: e.string().register(e.globalRegistry, { description: "The principal who crated the note." }),
	text: e.string().register(e.globalRegistry, { description: "The text of the note." }),
	author: e.string().register(e.globalRegistry, { description: "The author of the note." }).optional(),
	locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional(),
	updatedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]).optional()
}), rn = e.union([e.object({ type: e.literal("IMPORTED") }).and(tn), e.object({ type: e.literal("PRINCIPAL") }).and(nn)]), Z = e.union([
	e.object({
		address: z,
		location: e.object({
			name: e.string().register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().register(e.globalRegistry, { description: "The location code of the pickup location." }).optional(),
			type: e.union([e.enum([
				"CLICK_COLLECT",
				"PARCEL_LOCKER",
				"PARCEL_POINT",
				"POST_OFFICE",
				"POST_POINT"
			]), e.string()]).register(e.globalRegistry, { description: "The bpost pickup location type." })
		}).register(e.globalRegistry, { description: "The pickup location details." })
	}).register(e.globalRegistry, { description: "The bpost pickup details." }),
	e.object({
		address: z,
		location: e.object({
			name: e.string().register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().register(e.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(e.globalRegistry, { description: "The pickup location details." }),
		retailNetworkId: e.union([e.enum(["PNPNL-01", "PNPBE-01"]), e.string()]).register(e.globalRegistry, { description: "PostNL Retail network ID." })
	}).register(e.globalRegistry, { description: "The PostNL pickup details." }),
	e.object({
		address: z,
		location: e.object({
			name: e.string().register(e.globalRegistry, { description: "The name of the pickup location." }),
			code: e.string().register(e.globalRegistry, { description: "The location code of the pickup location." }).optional()
		}).register(e.globalRegistry, { description: "The pickup location details." })
	}).register(e.globalRegistry, { description: "The general pickup details." })
]), an = e.object({
	carrier: B,
	direction: G,
	disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
	packageType: e.union([e.enum([
		"DIGITAL_STAMP",
		"ENVELOPE",
		"MAILBOX",
		"PACKAGE",
		"PALLET",
		"SMALL_PACKAGE",
		"UNFRANKED"
	]), e.string()]).register(e.globalRegistry, { description: "The type of the package." }),
	recipient: e.object({
		address: z,
		contact: X
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	delivery: V.optional(),
	options: K.optional(),
	pickup: Z.optional(),
	sender: e.object({
		address: z,
		contact: Y
	}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
}), on = e.object({
	id: e.string().register(e.globalRegistry, { description: "The unique identifier of the shipment." }),
	carrier: B,
	createdAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	direction: G,
	hidden: e.boolean().register(e.globalRegistry, { description: "Whether the shipment is hidden." }),
	packageType: U,
	recipient: e.object({
		address: z.optional(),
		contact: X.optional()
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
	customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: jt.optional(),
	delivery: V.optional(),
	dropOff: Ft.optional(),
	label: e.union([$t, en]).optional(),
	multicollo: e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier for a multicollo shipment group." }),
		totalPackages: e.int().gte(2).lte(20).register(e.globalRegistry, { description: "The total number of individual packages included within this specific multicollo shipment group." })
	}).register(e.globalRegistry, { description: "Details if this package is part of a multi-package (multicollo) shipment. A multicollo shipment is a group of packages belonging to the same shipment that are consolidated for combined labeling and potential cost reduction. This object will only be present if the package is part of such a group." }).optional(),
	options: Ht.optional(),
	pickup: Z.optional(),
	price: It.optional(),
	sender: e.object({
		address: z,
		contact: Y
	}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
}).register(e.globalRegistry, { description: "The shipment properties of a package." }), sn = e.object({ sourceId: e.string().register(e.globalRegistry, { description: "The order line ID as defined in the source system." }) }).register(e.globalRegistry, { description: "The external reference of the order line." }), cn = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
	product: e.object({
		name: e.string().register(e.globalRegistry, { description: "The name of the product." }),
		ean: e.union([e.string(), e.string()]).optional(),
		sku: e.string().register(e.globalRegistry, { description: "The SKU of the product." }).optional(),
		id: e.uuid().register(e.globalRegistry, { description: "Identifier of the product. This is always undefined when the `status` is `DISCOVERED` or `IMPORT_REQUESTED`, otherwise it is always defined." }).optional()
	}).register(e.globalRegistry, { description: "The product of an order line." }),
	quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity of the product of the order line." }),
	externalReference: sn.optional(),
	price: It.and(e.unknown().register(e.globalRegistry, { description: "The price of the product of the order line." })).optional()
}).register(e.globalRegistry, { description: "The line of the order" }), ln = e.object({
	customsDeclaration: At.optional(),
	options: q.optional(),
	physicalProperties: W.optional()
}), un = e.object({
	lines: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity of the product of the order line." })
	})).optional(),
	physicalProperties: W.optional()
}), dn = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." }),
	status: Rt,
	physicalProperties: Bt.optional(),
	lines: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a line of an order." }),
		quantity: e.int().gte(1).register(e.globalRegistry, { description: "The quantity that the package contains" })
	})).register(e.globalRegistry, { description: "The order lines related to the package." }).optional(),
	shipment: on.optional()
}), fn = e.object({
	customsDeclaration: At.optional(),
	options: q.optional(),
	physicalProperties: W.optional(),
	shipment: e.object({
		carrier: Ot,
		direction: G,
		disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
		packageType: U,
		recipient: e.object({
			address: z,
			contact: X
		}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
		customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
		delivery: V.optional(),
		options: K.optional(),
		pickup: Z.optional(),
		sender: e.object({
			address: z,
			contact: Y
		}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
	})
}), pn = e.object({
	carrier: B.optional(),
	customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
	customsDeclaration: jt.optional(),
	delivery: V.optional(),
	direction: G.optional(),
	disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }).optional(),
	numberOfLabels: e.int().gte(1).lte(20).optional(),
	options: Ht.optional(),
	packageType: U.optional(),
	pickup: Z.optional(),
	recipient: e.object({
		address: z.optional(),
		contact: X.optional()
	}).register(e.globalRegistry, { description: "The recipient of the shipment." }).optional()
}).register(e.globalRegistry, { description: "The shipping preferences of the order. This should be used as default information when preparing packages for shipment." }), mn = e.union([e.object({
	shopId: e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: Mt.optional(),
	package: fn
}), e.object({
	shopId: e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	customerReference: Mt.optional(),
	multicollo: e.object({
		packages: e.array(ln),
		shipment: e.object({
			carrier: Ot,
			direction: G,
			disableAutoDetectPickup: e.boolean().register(e.globalRegistry, { description: "When set to true, this field disables the automatic detection and change of a recipient's address to a pickup location, particularly when the recipient's address is very close to or within the same building as a pickup point." }),
			packageType: U,
			recipient: e.object({
				address: z,
				contact: X
			}).register(e.globalRegistry, { description: "The recipient of the shipment." }),
			customContractId: e.string().register(e.globalRegistry, { description: "The unique identifier of the contract." }).optional(),
			delivery: V.optional(),
			options: K.optional(),
			pickup: Z.optional(),
			sender: e.object({
				address: z,
				contact: Y
			}).register(e.globalRegistry, { description: "The sender of the shipment." }).optional()
		})
	})
})]), hn = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	packages: e.array(un)
}), gn = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." }),
	customsDeclaration: At.optional(),
	options: q.optional(),
	physicalProperties: W.optional()
}), _n = e.union([e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: an,
	packages: e.array(gn)
}), e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	shipment: an,
	multicollo: e.array(gn)
})]), vn = e.object({
	id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
	orderedAt: e.union([e.string(), e.iso.datetime().register(e.globalRegistry, { description: "An ISO 8601 formatted datetime string with timezone offset." })]),
	price: It,
	shopId: e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." }),
	status: H,
	assignedUserId: e.string().register(e.globalRegistry, { description: "The user ID assigned to the order." }).optional(),
	billingDetails: qt.optional(),
	customerReference: Mt.optional(),
	externalReferences: Qt.and(e.unknown().register(e.globalRegistry, { description: "The external references of the order. These are read-only and automatically populated by the system based on the source." })).optional(),
	lines: e.array(cn).register(e.globalRegistry, { description: "The lines of the order" }).optional(),
	notes: e.array(rn).register(e.globalRegistry, { description: "The notes of the order." }).optional(),
	packages: e.array(dn).register(e.globalRegistry, { description: "The packages of the order." }).optional(),
	shipping: pn.optional()
}), yn = e.object({
	type: e.union([e.enum([
		"about:blank",
		"urn:problem:client",
		"urn:problem:invalid-request-syntax",
		"urn:problem:not-found",
		"urn:problem:server",
		"urn:problem:unauthorized",
		"urn:problem:unsupported-media-type"
	]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }),
	status: e.union([
		e.literal(400),
		e.literal(401),
		e.literal(404),
		e.literal(415),
		e.literal(500)
	]).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }),
	title: e.string().register(e.globalRegistry, { description: "A short human-readable summary of the problem type." }),
	detail: e.string().register(e.globalRegistry, { description: "A human-readable explanation specific to this occurrence of the problem." }),
	instance: e.url().register(e.globalRegistry, { description: "A URI reference that identifies the specific occurrence of the problem." }),
	cause: e.unknown().register(e.globalRegistry, { description: "The cause of this problem when debug mode is enabled." }).optional()
}), Q = yn.and(e.object({
	type: e.union([e.enum(["urn:problem:client"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string(),
		pointer: e.string().register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(e.globalRegistry, { description: "Detailed information regarding the violations." })
})), $ = yn.and(e.object({
	type: e.union([e.enum(["urn:problem:server"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(500).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional()
}));
yn.and(e.object({
	type: e.union([e.enum(["urn:problem:invalid-request-syntax"]), e.string()]).register(e.globalRegistry, { description: "A URI reference that identifies the problem type." }).optional(),
	status: e.literal(400).register(e.globalRegistry, { description: "The HTTP status code generated by the origin server." }).optional(),
	errors: e.array(e.object({
		detail: e.string(),
		pointer: e.string().register(e.globalRegistry, { description: "This is a JSON pointer to the request (body, parameters, ...). When an aggregate has a conflict (e.g. not allowed due to the status) this value is for bulk request on the index (/body/{index}) and for any other on root (/)." })
	})).register(e.globalRegistry, { description: "Detailed information regarding the syntactic violations." })
})), e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		text: e.string().register(e.globalRegistry, { description: "The text of the note." }),
		author: e.string().register(e.globalRegistry, { description: "The author of the note." }).optional(),
		locale: e.union([e.string().register(e.globalRegistry, { description: "Combination of ISO 639-1 and ISO 3166-1 alpha-2 separated by a hyphen." }), e.string().register(e.globalRegistry, { description: "ISO 639-1 language code." })]).optional()
	})).register(e.globalRegistry, { description: "Body for adding an order note." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var bn = e.array(e.union([
	e.object({
		status: e.literal(200),
		ids: e.array(e.uuid()).min(1)
	}),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		userId: e.string().register(e.globalRegistry, { description: "User to assign to these orders." })
	})).register(e.globalRegistry, { description: "Body for assigning orders to an user." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var xn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).register(e.globalRegistry, { description: "Body for canceling orders." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Sn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(mn).register(e.globalRegistry, { description: "Body for creating an order with shippable packages." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Cn = e.array(e.union([
	e.object({
		status: e.literal(201),
		id: e.uuid()
	}),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per item." });
e.object({
	body: e.array(hn).register(e.globalRegistry, { description: "Body adding packages to orders" }),
	path: e.never().optional(),
	query: e.never().optional()
});
var wn = e.array(e.union([
	e.object({
		status: e.literal(200),
		ids: e.array(e.uuid()).min(1)
	}),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(_n).register(e.globalRegistry, { description: "Body preparing packages for shipment" }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Tn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		packageIds: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." })).min(1).max(25)
	})).register(e.globalRegistry, { description: "Body for unpreparing packages for shipment" }),
	path: e.never().optional(),
	query: e.never().optional()
});
var En = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		noteId: e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." }),
		text: e.string().register(e.globalRegistry, { description: "The text of the note." })
	})).register(e.globalRegistry, { description: "Body for editing an order note." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Dn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).register(e.globalRegistry, { description: "Body for importing an order." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var On = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		aggregation: e.tuple([Dt]).register(e.globalRegistry, { description: "Fields to summarize data for based on the query." }).optional(),
		filter: e.object({
			assignedUserId: e.array(e.string().register(e.globalRegistry, { description: "The unique identifier of the user." })).optional(),
			carrier: e.array(B).optional(),
			hasAssignedUser: e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "Whether the order has an assigned user or not." }).optional(),
			hasNotes: e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "Whether the order has notes or not." }).optional(),
			orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).optional(),
			orderedAt: e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a datetime in ISO 8601 format." })).optional(),
			packageStatusGroup: e.array(e.union([e.enum([
				"PICKING_AND_PACKING",
				"DISPATCHING",
				"UNTRACEABLE",
				"SORTING",
				"DISTRIBUTING",
				"DELIVERED"
			]), e.string()])).optional(),
			packageType: e.array(U).optional(),
			price: e.array(e.string().register(e.globalRegistry, { description: "Inequality symbol 'gt', 'gte', 'lt', 'lte' with a number with a maximum precision of 2." })).optional(),
			regionCode: e.array(Vt).optional(),
			salesChannelId: e.array(e.string().register(e.globalRegistry, { description: "The unique identifier of the sales channel." })).optional(),
			shipmentDelayed: e.union([e.enum(["true", "false"]), e.string()]).register(e.globalRegistry, { description: "Whether the order has a package with a delayed shipment or not." }).optional(),
			shipmentDirection: e.array(G).optional(),
			shipmentPaymentStatus: e.array(zt).optional(),
			shopId: e.array(e.string().register(e.globalRegistry, { description: "The unique identifier of the shop." })).optional(),
			status: e.array(H).optional()
		}).optional(),
		limit: e.int().gte(0).lte(50).nullish().default(50),
		pageToken: e.string().register(e.globalRegistry, { description: "The page token to retrieve the next page of orders." }).optional(),
		query: e.string().register(e.globalRegistry, { description: "The following operators are supported:\n'+ signifies AND operation'\n'| signifies OR operation'\n'- negates a single token'\n'\" wraps a number of tokens to signify a phrase for searching'\n'* at the end of a term signifies a prefix query'\n'( and ) signify precedence'\n'~N after a word signifies edit distance (fuzziness)'\n'~N after a phrase signifies slop amount'\nTo use one of these characters literally, escape it with a preceding backslash (\\)." }).optional(),
		sort: e.object({
			customerReference: J.optional(),
			orderedAt: J.optional(),
			price: J.optional(),
			sourceId: J.optional()
		}).register(e.globalRegistry, { description: "When no `query` is provided the default sort is by `orderedAt` descending. When a `query` is provided the default sort is by relevance." }).optional()
	}).optional()
});
var kn = e.object({
	results: e.array(vn).register(e.globalRegistry, { description: "The list of orders." }),
	total: e.object({
		relation: e.union([e.enum(["eq", "gte"]), e.string()]).register(e.globalRegistry, { description: "The relation of the total number of orders." }),
		value: e.int().gte(0).register(e.globalRegistry, { description: "The total number of orders." })
	}),
	aggregations: e.object({ status: e.tuple([
		e.object({
			key: H,
			count: e.int().gte(0)
		}),
		e.object({
			key: H,
			count: e.int().gte(0)
		}),
		e.object({
			key: H,
			count: e.int().gte(0)
		}),
		e.object({
			key: H,
			count: e.int().gte(0)
		}),
		e.object({
			key: H,
			count: e.int().gte(0)
		}),
		e.object({
			key: H,
			count: e.int().gte(0)
		}),
		e.object({
			key: H,
			count: e.int().gte(0)
		})
	]).optional() }).optional(),
	nextPageToken: e.string().register(e.globalRegistry, { description: "The next page token to retrieve the next page of orders." }).optional()
}).register(e.globalRegistry, { description: "The found orders." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({
		shipmentLabelsLayout: e.union([e.enum(["INTERLEAVED"]), e.string()]).register(e.globalRegistry, { description: "How shipment labels are included alongside the packing slips in the resulting PDF. `INTERLEAVED` outputs each packing slip immediately followed by its shipment label. When the parameter is omitted, no shipment labels are included and only packing slips are rendered." }).optional(),
		orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).register(e.globalRegistry, { description: "The orderId of the order to include in the packing slips. A maximum of 50 orders can be included in the request. When packageId is provided, exactly one orderId is allowed." }),
		packageId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the package." })).register(e.globalRegistry, { description: "The packageId of the package to include in the packing slips. The packageIds must belong to the single orderId in the request and a maximum of 20 packageIds can be included." }).optional()
	}),
	headers: e.object({ Accept: e.union([e.enum(["application/pdf"]), e.string()]) })
});
var An = e.string().register(e.globalRegistry, { description: "Packing slips PDF." });
e.object({
	body: e.never().optional(),
	path: e.never().optional(),
	query: e.object({ orderId: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." })).register(e.globalRegistry, { description: "The orderId of the order to include in the picklist. A maximum of 50 orders can be included in the request." }) }),
	headers: e.object({ Accept: e.union([e.enum(["application/pdf"]), e.string()]) })
});
var jn = e.string().register(e.globalRegistry, { description: "Picklist PDF." });
e.object({
	body: e.array(e.object({
		id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }),
		noteIds: e.array(e.uuid().register(e.globalRegistry, { description: "The unique identifier of a note of an order." })).min(1).max(150).register(e.globalRegistry, { description: "Note IDs to remove from the order." })
	})).register(e.globalRegistry, { description: "Body for removing order notes." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Mn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." });
e.object({
	body: e.array(e.object({ id: e.uuid().register(e.globalRegistry, { description: "The unique identifier of the order." }) })).register(e.globalRegistry, { description: "Body for unassigning orders from an user." }),
	path: e.never().optional(),
	query: e.never().optional()
});
var Nn = e.array(e.union([
	e.object({ status: e.literal(200) }),
	Q,
	$
])).register(e.globalRegistry, { description: "The result per ID." }), Pn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await $e.parseAsync(e),
	responseValidator: async (e) => await bn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/add-note",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Fn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await tt.parseAsync(e),
	responseValidator: async (e) => await xn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/assign-to-user",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), In = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await rt.parseAsync(e),
	responseValidator: async (e) => await Sn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/cancel",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Ln = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await at.parseAsync(e),
	responseValidator: async (e) => await Cn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/create-from-shippable-packages",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Rn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await st.parseAsync(e),
	responseValidator: async (e) => await wn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/add-packages",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), zn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await lt.parseAsync(e),
	responseValidator: async (e) => await Tn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/prepare-packages-for-shipment",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Bn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await dt.parseAsync(e),
	responseValidator: async (e) => await En.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/unprepare-packages-for-shipment",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Vn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await pt.parseAsync(e),
	responseValidator: async (e) => await Dn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/edit-note",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Hn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await ht.parseAsync(e),
	responseValidator: async (e) => await On.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/import",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), Un = (e) => (e?.client ?? g).get({
	requestValidator: async (e) => await _t.parseAsync(e),
	responseValidator: async (e) => await kn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/orders",
	...e
}), Wn = (e) => (e.client ?? g).get({
	requestValidator: async (e) => await yt.parseAsync(e),
	responseValidator: async (e) => await An.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/packing-slips",
	...e
}), Gn = (e) => (e.client ?? g).get({
	requestValidator: async (e) => await xt.parseAsync(e),
	responseValidator: async (e) => await jn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/picklist",
	...e
}), Kn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await Ct.parseAsync(e),
	responseValidator: async (e) => await Mn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/remove-notes",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
}), qn = (e) => (e.client ?? g).post({
	requestValidator: async (e) => await Tt.parseAsync(e),
	responseValidator: async (e) => await Nn.parseAsync(e),
	security: [{
		name: "Authorization",
		type: "apiKey"
	}, {
		scheme: "bearer",
		type: "http"
	}],
	url: "/unassign-from-user",
	...e,
	headers: {
		"Content-Type": "application/json",
		...e.headers
	}
});
//#endregion
export { Re as $, t as $t, y as A, wt as At, je as B, Qe as Bt, N as C, pt as Ct, he as D, lt as Dt, Te as E, gt as Et, ye as F, Xe as Ft, bt as G, O as Gt, _t as H, Be as Ht, Ae as I, F as It, Pe as J, Ke as Jt, xt as K, k as Kt, ke as L, I as Lt, x as M, Et as Mt, ve as N, dt as Nt, Je as O, ut as Ot, _e as P, ft as Pt, S as Q, n as Qt, Ne as R, L as Rt, we as S, ot as St, De as T, ht as Tt, vt as U, D as Ut, be as V, Ce as Vt, yt as W, A as Wt, He as X, j as Xt, Fe as Y, qe as Yt, Ve as Z, g as Zt, pe as _, tt as _t, Rn as a, We as at, me as b, it as bt, Ln as c, w as ct, zn as d, E as dt, Ie as et, Kn as f, P as ft, _ as g, ct as gt, Ye as h, st as ht, Pn as i, Ue as it, ge as j, Tt as jt, b as k, Ct as kt, Vn as l, T as lt, Bn as m, et as mt, Wn as n, Ze as nt, Fn as o, Ge as ot, qn as p, $e as pt, St as q, ze as qt, Gn as r, C as rt, In as s, xe as st, Un as t, Le as tt, Hn as u, Se as ut, Oe as v, nt as vt, Ee as w, mt as wt, M as x, at as xt, v as y, rt as yt, Me as z, R as zt };
